export default "__VITE_ASSET__Djy1$p7H__"